import { useOutletContext } from 'react-router';

import type { ReferralSummary, SubscriptionsSummary } from './subscriptions-types';

export interface SubscriptionsOutletContext {
  summary?: SubscriptionsSummary;
  summaryLoading: boolean;
  referral?: ReferralSummary;
}

export const useSubscriptionsContext = () => useOutletContext<SubscriptionsOutletContext>();
